import van11yAccessibleAccordionAria from "van11y-accessible-accordion-aria";

export default class Accordion {

  constructor(selector) {
  }

}


// WEBPACK FOOTER //
// ./src/js/accordion.js